import { AsyncPipe } from '@angular/common';
import { Component, HostBinding, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ServiceWorkerService, SplashService } from '@context/frontend/common';
import { ChemicalService } from '@context/frontend/chemical';
import { ContentService } from '@context/frontend/content';
import { getOS, getUaDevice } from '@context/frontend/native/platform';
import { TuiLoader, TuiRoot } from '@taiga-ui/core';
import { filter } from 'rxjs';

@Component({
	imports: [TuiRoot, RouterModule, TuiLoader, AsyncPipe],
	selector: 'ctx-root',
	templateUrl: 'app.component.html',
	styleUrl: 'app.component.scss',
	host: {
		'[attr.device]': 'device',
		'[attr.os]': 'os',
	},
})
export class AppComponent implements OnInit {
	readonly device = getUaDevice();

	readonly os = getOS();

	private readonly router = inject(Router);
	private readonly contentService = inject(ContentService);
	private readonly chemicalService = inject(ChemicalService);
	private readonly swService = inject(ServiceWorkerService);
	public readonly splash = inject(SplashService);

	ngOnInit() {
		this.swService.checkForUpdate$.subscribe();
		this.router.events
			.pipe(filter((value) => value instanceof NavigationEnd))
			.subscribe((value) => this.onRouterEnd(value));
	}

	onRouterEnd(value: NavigationEnd) {
		this.determineOpenContent(value.url);
	}

	determineOpenContent(url: string) {
		const pathname = url.split('?')[0];
		// first segment is empty when path starts with /
		const path = pathname.split('/').slice(1);

		let folderId = null;
		if (path[1] === 'folder' && typeof path[2] === 'string') {
			folderId = path[2];
		}
		this.contentService.setOpenFolder(folderId);

		let fileId = null;
		const fileIdx = path.indexOf('file');
		if (
			fileIdx >= 0 &&
			typeof path[fileIdx + 1] === 'string' &&
			path[fileIdx + 1] !== 'create'
		) {
			fileId = path[fileIdx + 1];
		}
		this.contentService.setOpenFile(fileId);

		let chemicalId = null;
		const catalogIdx = path.indexOf('catalog');
		if (
			catalogIdx >= 0 &&
			typeof path[catalogIdx + 1] === 'string' &&
			path[catalogIdx + 1] !== 'create'
		) {
			chemicalId = path[catalogIdx + 1];
		}
		this.chemicalService.setOpenChemical(chemicalId);
	}
}
